import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const BlutdruckPage = () => {
  return (
    <Layout>
      <PageHero
        title="Langzeit-Blutdruck: Exakte Messung über 24 Stunden"
        subtitle="Wir ermitteln Ihren Blutdruckverlauf über einen ganzen Tag für eine präzise Beurteilung."
        backgroundImage="/images/Content_Behandlung_9.webp"
        ctaText="Langzeit-Blutdruck-Termin buchen"
      />

      <ContentSection
        title="Blutdruck richtig einschätzen"
        content="Ein einzelner Blutdruckwert kann täuschen. Mit der Langzeit-Blutdruckmessung erfassen wir Ihren Blutdruck über 24 Stunden hinweg in Ihrem alltäglichen Umfeld. Dies hilft uns, Schwankungen zu erkennen, den Schweregrad von Bluthochdruck besser einzuschätzen und die Wirksamkeit Ihrer Therapie zu überprüfen."
        image="/images/Content_Behandlung_9.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="24h Blutdruckmessung in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh führt Langzeit-Blutdruckmessungen durch, um eine genaue Diagnose und optimale Behandlung von Bluthochdruck zu gewährleisten."
      />

      <CTASection
        title="Lassen Sie Ihren Blutdruck genau überprüfen"
        subtitle="Vereinbaren Sie einen Termin für die Langzeit-Blutdruckmessung."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default BlutdruckPage;
